// PostHog client bootstrap. Server-side events (Signal::Analytics) are the funnel's
// source of truth; this side adds Turbo-aware pageviews, stitches the anonymous
// device id into user_{id} at sign-in (identify), tags the team group, and starts
// session replay only where the layout opted in. Config arrives via meta tags from
// app/views/layouts/_posthog.html.erb — no key in the page means no-op.
import posthog from "posthog-js"

let initialized = false

const meta = (name) => document.querySelector(`meta[name="${name}"]`)

function ensureInit() {
  if (initialized) return true
  const key = meta("posthog-key")?.content
  if (!key) return false

  posthog.init(key, {
    api_host: meta("posthog-host")?.content,
    ui_host: meta("posthog-ui-host")?.content,
    // Turbo navigations don't reload the page — we emit $pageview on turbo:load
    // ourselves, so the built-in capture would double-count the first load.
    capture_pageview: false,
    capture_pageleave: true,
    person_profiles: "identified_only",
    // Started explicitly below, only on pages carrying the ph-record meta.
    disable_session_recording: true,
    session_recording: { maskAllInputs: true },
  })
  initialized = true
  return true
}

// Lightweight product telemetry for bounded, sampled browser measurements.
// Keeping this behind the same initializer means environments without PostHog
// remain a strict no-op.
export function captureClientEvent(name, properties = {}) {
  if (ensureInit()) posthog.capture(name, properties)
}

document.addEventListener("turbo:load", () => {
  if (!ensureInit()) return

  posthog.capture("$pageview")

  const identify = meta("ph-identify")
  if (identify && posthog.get_distinct_id() !== identify.content) {
    posthog.identify(identify.content, { email: identify.dataset.email })
  }

  const group = meta("ph-group-team")
  if (group) posthog.group("team", group.content, { name: group.dataset.name })

  if (meta("ph-record")) posthog.startSessionRecording()
})
